import { COURTOIS_URL } from '@/config'

export const getCourtoisUrl = (path: string) => {
  return `${COURTOIS_URL}${path}`
}

export const getCourtoisTermsUrl = () => getCourtoisUrl('/terms')
export const getCourtoisPrivacyUrl = () => getCourtoisUrl('/privacy')
export const getCourtoisDemoUrl = () => getCourtoisUrl('/demo')
export const getCourtoisSecurityUrl = () => getCourtoisUrl('/security')
export const getCourtoisSubprocessorsUrl = () =>
  getCourtoisUrl('/subprocessors')
